import JsonLdComponent from '@rentivo/gatsby-core/src/components/schema/JsonLd/component';

JsonLdComponent.defaultProps = {
  context: 'https://schema.org'
};

export default JsonLdComponent;
